import React, { useEffect, useState } from 'react';
import { makeStyles, tokens, Tooltip } from '@fluentui/react-components';
import { Checkmark20Regular, Dismiss20Regular } from '@fluentui/react-icons';
import { ChatAPI } from '../utils/api';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
  },
  iconGreen: {
    color: tokens.colorPaletteGreenForeground1,
  },
  iconRed: {
    color: tokens.colorPaletteRedForeground1,
  },
});

const ConnectionIndicator: React.FC = () => {
  const classes = useStyles();
  const [available, setAvailable] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;
    const check = async () => {
      try {
        const health = await ChatAPI.healthCheck();
        if (!mounted) return;
        setAvailable(health.status === 'healthy');
      } catch (err) {
        if (!mounted) return;
        setAvailable(false);
      }
    };

    check();
    // Also refresh every 30s when mounted
    const id = setInterval(check, 30000);
    return () => { mounted = false; clearInterval(id); };
  }, []);

  if (available === null) {
    return <div className={classes.container} aria-hidden />;
  }

  return (
    <Tooltip content={available ? 'Connected to backend' : 'Disconnected'} relationship="label">
      <div className={classes.container} role="img" aria-label={available ? 'Connected' : 'Disconnected'}>
        {available ? <Checkmark20Regular className={classes.iconGreen} /> : <Dismiss20Regular className={classes.iconRed} />}
      </div>
    </Tooltip>
  );
};

export default ConnectionIndicator;
